export default __webpack_public_path__ + "static/media/play-icon.420b0328.svg";